import logo200Image from "../../assets/img/logo/Logo.png";
import sidebarBgImage from "../../assets/img/sidebar/sidebar.jpg";

import AuthContext from "../../context/autenticacion/authContext";
import colegioContext from "../../context/colegios/colegioContext";
import GeneralContext from "../../context/general/generalContext";

import React, { useState, useContext, useEffect } from "react";
import {
  MdAccountCircle,
  MdKeyboardArrowDown,
  MdSend,
  MdHome,
  MdPersonOutline,
  MdEvent,
  MdAttachMoney,
  MdBusiness,
} from "react-icons/md";
import { FaSchool, FaExchangeAlt, FaUserTie } from "react-icons/fa";
import { AiOutlineQrcode } from "react-icons/ai";
import { BsFillInboxesFill } from "react-icons/bs";
import { FiLogOut } from "react-icons/fi";
import { NavLink, Redirect } from "react-router-dom";
import { Collapse, Nav, Navbar, NavItem, NavLink as BSNavLink } from "reactstrap";
import bn from "../../utils/bemnames";
import {
  can,
  hasModule,
  isGestorProyectos,
  isPlatformAdmin,
  isHattTenant,
} from "../../utils/permissions";

function Sidebar() {
  const colegiosContext = useContext(colegioContext);
  const { limpiarColegios, detallescolegioseleccionado } = colegiosContext;

  const authContext = useContext(AuthContext);
  const { cerrarSesion, usuarioAutenticado, usuario: usuarioContextActual } = authContext;

  const generalContext = useContext(GeneralContext);
  const { resetDasboard, rutaActualGlobal, rutaactualglobal } = generalContext;

  const [isOpenS, setIsOpen] = useState({
    isOpenPlatform: true,
    isOpenComponents: true,
    isOpenPages: true,
    isOpenInventario: true,
    isOpenProyectos: true,
  });

  const usuarioStorage = JSON.parse(localStorage.getItem("usuario"));
  const usuario = usuarioContextActual || usuarioStorage;
  const platformAdmin = isPlatformAdmin(usuario);
  const gestorProyectos = isGestorProyectos(usuario);
  const tenantLabel = (usuario && usuario.tenant && usuario.tenant.nombre) || "HATT";
  const tenantLogo = (usuario && usuario.tenant && usuario.tenant.logo_url) || logo200Image;
  const legacyMode = isHattTenant(usuario) && !Array.isArray(usuario && usuario.modules);
  const puedeAdministrarUsuarios = Boolean(
    !gestorProyectos &&
      (platformAdmin ||
        can("users.manage", usuario) ||
        (usuario && usuario.is_tenant_admin) ||
        (usuario && usuario.tenant && usuario.tenant.is_tenant_admin))
  );
  const puedeVerCertificados = Boolean(
    !gestorProyectos &&
      usuario &&
      hasModule("certificados", usuario) &&
      (platformAdmin ||
        can("certificates.read", usuario) ||
        usuario.is_tenant_admin ||
        (usuario.tenant && usuario.tenant.is_tenant_admin) ||
        usuario.certificados_activo ||
        usuario.certificados_rol === "profesor")
  );
  const puedeVerContabilidadV2 = Boolean(
    !gestorProyectos &&
      hasModule("contabilidad", usuario) &&
      (platformAdmin || can("accounting.read", usuario) || can("accounting.manage", usuario))
  );

  const legacySuperAdmin = Boolean(
    legacyMode && usuario && usuario.is_admin && usuario.is_supervisor === false && usuario.is_generador === false
  );
  const legacyInventario = Boolean(
    legacyMode && usuario && usuario.is_admin === false && usuario.is_supervisor === false && usuario.is_generador === false
  );
  const legacySucursal = Boolean(
    legacyMode && usuario && usuario.is_admin === false && usuario.is_supervisor && usuario.is_generador === false
  );
  const legacyProyectos = Boolean(
    legacyMode && usuario && usuario.is_admin === false && usuario.is_supervisor === false && usuario.is_generador
  );

  const splitURLActual = window.location.href.split("/#/");
  const rutaActual = splitURLActual[1];

  const bem = bn.create("sidebar");

  useEffect(() => {
    usuarioAutenticado();
    rutaActualGlobal(rutaActual);
    if (rutaActual !== "dashboard") resetDasboard();
    // eslint-disable-next-line
  }, [rutaActual, rutaactualglobal]);

  const handleClick = (name) => () => {
    setIsOpen((prevState) => ({ ...prevState, [`isOpen${name}`]: !prevState[`isOpen${name}`] }));
  };

  const terminarSesion = () => {
    cerrarSesion();
    limpiarColegios();
  };

  const sidebarBackground = {
    backgroundImage: `url("${sidebarBgImage}")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  };

  const renderItems = (items, className = "font-italic") =>
    items.filter(Boolean).map(({ to, name, exact, Icon }, index) => (
      <NavItem key={`${to}-${index}`} className={bem.e("nav-item")}>
        <BSNavLink
          id={`navItem-${name}-${index}`}
          className={className}
          tag={NavLink}
          to={to}
          activeClassName="active"
          exact={exact}
          onClick={() => resetDasboard()}
        >
          <Icon className={bem.e("nav-item-icon")} />
          <span>{name}</span>
        </BSNavLink>
      </NavItem>
    ));

  const CollapseHeader = ({ name, label }) => (
    <NavItem className={bem.e("nav-item")} onClick={handleClick(name)}>
      <BSNavLink className={bem.e("nav-item-collapse")} onClick={() => resetDasboard()}>
        <div className="d-flex">
          <MdSend className={bem.e("nav-item-icon")} />
          <span className="align-self-start font-weight-bold">{label}</span>
        </div>
        <MdKeyboardArrowDown
          className={bem.e("nav-item-icon")}
          style={{
            padding: 0,
            transform: isOpenS[`isOpen${name}`] ? "rotate(0deg)" : "rotate(-90deg)",
            transitionDuration: "0.3s",
            transitionProperty: "transform",
          }}
        />
      </BSNavLink>
    </NavItem>
  );

  if (usuario === null) return <Redirect to="/" />;

  const subMenuDashboard = gestorProyectos
    ? []
    : [{ to: "/dashboard", name: "Dashboard", exact: false, Icon: MdHome }];

  const subMenuPlatform = platformAdmin
    ? [{ to: "/platform/empresas", name: "Panel SaaS HATT", exact: false, Icon: MdBusiness }]
    : [];

  const subMenuAdministrar = gestorProyectos
    ? []
    : [
        puedeAdministrarUsuarios && { to: "/usuarios", name: "Usuarios", exact: false, Icon: MdAccountCircle },
        hasModule("sucursales", usuario) && { to: "/sucursales", name: "Sucursales", exact: false, Icon: FaSchool },
        hasModule("codigos", usuario) && { to: "/codigos", name: "Codigos", exact: false, Icon: AiOutlineQrcode },
      ].filter(Boolean);

  const subMenuProyectos = gestorProyectos
    ? [
        hasModule("proyectos", usuario) &&
          can("projects.read", usuario) && {
            to: "/eventos",
            name: "Proyectos",
            exact: false,
            Icon: MdEvent,
          },
        can("clients_providers.read", usuario) && {
          to: "/clientesProveedores",
          name: "Cliente/Proveedor",
          exact: false,
          Icon: FaUserTie,
        },
      ].filter(Boolean)
    : [
        hasModule("proyectos", usuario) && { to: "/eventos", name: "Proyectos", exact: false, Icon: MdEvent },
        puedeVerCertificados && { to: "/certificados", name: "Certificados", exact: false, Icon: AiOutlineQrcode },
        hasModule("contabilidad", usuario) && { to: "/contabilidad", name: "Contabilidad", exact: false, Icon: MdAttachMoney },
        puedeVerContabilidadV2 && { to: "/contabilidad-v2", name: "Contabilidad 2 · Nueva", exact: false, Icon: MdAttachMoney },
        hasModule("flujo_caja", usuario) && { to: "/flujo-caja", name: "Flujo de Caja", exact: false, Icon: MdAttachMoney },
        hasModule("clientes_proveedores", usuario) && { to: "/clientesProveedores", name: "Cliente/Proveedor", exact: false, Icon: FaUserTie },
      ].filter(Boolean);

  const subMenuInventario = gestorProyectos
    ? []
    : [
        hasModule("inventario", usuario) && { to: "/inventario", name: "Inventario", exact: false, Icon: BsFillInboxesFill },
        hasModule("prestamos", usuario) && { to: "/prestamos", name: "Entrada / Salida", exact: false, Icon: FaExchangeAlt },
      ].filter(Boolean);

  const subMenuCerrarSesion = [
    { to: "/perfil", name: "Perfil", exact: false, Icon: MdPersonOutline },
    { to: "/", name: "Cerrar Sesión", exact: false, Icon: FiLogOut },
  ];

  const puedeVerProyectos = gestorProyectos
    ? can("projects.read", usuario) || can("clients_providers.read", usuario)
    : platformAdmin || legacySuperAdmin || legacyProyectos || can("projects.read", usuario);
  const puedeVerInventario = Boolean(
    !gestorProyectos &&
      (platformAdmin || legacySuperAdmin || legacySucursal || legacyInventario || can("inventory.read", usuario))
  );
  const puedeAdministrarEmpresa = Boolean(
    !gestorProyectos && (puedeAdministrarUsuarios || legacySuperAdmin)
  );

  return (
    <aside className={bem.b()} data-image={sidebarBgImage}>
      <div className={bem.e("background")} style={sidebarBackground} />
      <div className={bem.e("content")}>
        <Navbar className="navbar-brand d-flex flex-column align-items-start">
          <img
            src={tenantLogo}
            width="100"
            height="30"
            className="pr-2"
            alt={tenantLabel}
            onError={(event) => {
              event.currentTarget.onerror = null;
              event.currentTarget.src = logo200Image;
            }}
          />
          <small className="text-white-50 mt-1">{tenantLabel}</small>
        </Navbar>

        <Nav vertical>
          {renderItems(subMenuDashboard, "text-uppercase font-weight-bold")}

          {subMenuPlatform.length > 0 && (
            <>
              <CollapseHeader name="Platform" label="SaaS HATT" />
              <Collapse isOpen={isOpenS.isOpenPlatform}>{renderItems(subMenuPlatform)}</Collapse>
            </>
          )}

          {subMenuAdministrar.length > 0 && puedeAdministrarEmpresa && (
            <>
              <CollapseHeader name="Components" label="Administrar" />
              <Collapse isOpen={isOpenS.isOpenComponents}>{renderItems(subMenuAdministrar)}</Collapse>
            </>
          )}

          {subMenuProyectos.length > 0 && puedeVerProyectos && (
            <>
              <CollapseHeader name="Proyectos" label="Proyectos" />
              <Collapse isOpen={isOpenS.isOpenProyectos}>{renderItems(subMenuProyectos)}</Collapse>
            </>
          )}

          {puedeVerCertificados && !puedeVerProyectos && renderItems([{ to: "/certificados", name: "Certificados", exact: false, Icon: AiOutlineQrcode }], "text-uppercase font-weight-bold")}

          {detallescolegioseleccionado !== null && subMenuInventario.length > 0 && puedeVerInventario && (
            <>
              <CollapseHeader name="Inventario" label="Inventario" />
              <Collapse isOpen={isOpenS.isOpenInventario}>
                {legacyInventario && !platformAdmin && !legacySuperAdmin && !legacySucursal
                  ? renderItems(subMenuInventario.slice(0, 1))
                  : renderItems(subMenuInventario)}
              </Collapse>
            </>
          )}

          <CollapseHeader name="Pages" label="CUENTA" />
          <Collapse isOpen={isOpenS.isOpenPages}>
            {subMenuCerrarSesion.map(({ to, name, exact, Icon }, index) => (
              <NavItem key={index} className={bem.e("nav-item")}>
                <BSNavLink
                  id={`navItem-${name}-${index}`}
                  className="font-italic"
                  tag={NavLink}
                  to={to}
                  activeClassName={name === "Cerrar Sesión" ? "" : "active"}
                  exact={exact}
                  onClick={() => {
                    if (name === "Cerrar Sesión") terminarSesion();
                    resetDasboard();
                  }}
                >
                  <Icon className={bem.e("nav-item-icon")} />
                  <span>{name}</span>
                </BSNavLink>
              </NavItem>
            ))}
          </Collapse>
        </Nav>
      </div>
    </aside>
  );
}

export default Sidebar;